import React, { Component } from 'react';
import classnames from 'classnames';

import "./style.css";

class TileLocation extends Component {
  render() {
    return (
      <div className="row tile-location">
        <div className="col-xs-12 tile-left"></div>
        <div className="col-xs-12 tile-right">
          <div className="row tile-row">
            <div className={classnames('col-xs-12 tile-cell border', { filled: this.props.filled === "1" })}></div>
            <div className={classnames('col-xs-12 tile-cell', { filled: this.props.filled === "2" })}></div>
          </div>
          <div className="row tile-row">
            <div className={classnames('col-xs-12 tile-cell border', { filled: this.props.filled === "3" })}></div>
            <div className={classnames('col-xs-12 tile-cell', { filled: this.props.filled === "4" })}></div>
          </div>
          <div className="row tile-bottom-row">
            <div className={classnames('col-xs-12 tile-cell border', { filled: this.props.filled === "5" })}></div>
            <div className={classnames('col-xs-12 tile-cell', { filled: this.props.filled === "6" })}></div>
          </div>
        </div>
      </div>
    );
  }
}

export default TileLocation;



// WEBPACK FOOTER //
// ./src/components/admin/homepagemenu/tile-location.jsx